// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"4aacbe18","57":"4135703b","146":"e8b5f4f2","471":"0c61e582","630":"b55d7bc0","709":"3bad1802","754":"b39370c9","936":"17a9d4ae","965":"4049af3a"}[chunkId] + ".chunk.js";
};